import colorPalette from './colorPalette';

export default {
  template: '#right_control',
  components: {
    colorPalette,
  },
  props: ['selectedProduct'],
  data: function() {
    return {
      selectedProductColors: [],
      mainProductPricing: 0.00
    };
  },
  computed: {
    sortedColors: function() {
      if (this.selectedProductColors.length > 0)
        return this.getDesignerHelper().sortColors(this.selectedProductColors);
      else
        return [];
    }
  },
  created: function() {
    this.$on('on-product-select', function(selectedProduct) {
      this.selectedProductColors = _.filter(selectedProduct.product.product_colors, function(color) {
        return color.active == 1;
      });
    });

    this.$on('on-designer-tab-next-clicked', function() {
      this.goToDetails();
    });

    this.$on('on-designer-tab-launch-campaign-clicked', function() {
      this.goToLaunchCampaign();
    });

    this.$on('on-force-preview-campaign', function() {
      this.previewCampaign(true);
    });

    this.$on('pricing-recalculated', function() {
      if (this.$root.selectedProduct) {
        var screenPrice = this.$root.getPricingByProduct(this.$root.selectedProduct.product, this.$root.campaignData.goal, "MAIN"),
          dtgPrice = this.$root.getPricingByProduct(this.$root.selectedProduct.product, 1, "MAIN");

        this.mainProductPricing = dtgPrice < screenPrice ? dtgPrice : screenPrice;
      } else
        this.mainProductPricing = 0.00;
    });
  },
  methods: {
    goToDetails: function() {
      this.$root.outputDesign();
      var designItems = this.$root.designerItems;
      this.$root.unSelectAllControls();
      this.$root.$set('selectedItem', {});

      if ((this.isSublimationProduct() && this.isApparel() && !this.doesFrontAndBackDesignExist())) {
        helpers.alert('Sublimation Apparel products require both the front and back design.');
        return false;
      }

      if (designItems.front.length > 0 || designItems.back.length > 0) {
        //Showing the 2nd Tab of the Wizard
        $('#form_wizard_1').bootstrapWizard('show', 1);
        if (this.isSublimationProduct())
          this.$dispatch('force-preview-rendering');
      } else {
        if (this.isSublimationProduct()) {
          helpers.alert("Unfortunately, you can\'t sell a blank item. You need to upload a background image before you can continue");
        } else {
          helpers.alert("Unfortunately, you can\'t sell a blank item. You need to add text or art before you can continue.");
        }
      }
    },
    goToLaunchCampaign: function() {
      this.$root.outputDesign();
      var designItems = this.$root.designerItems;
      this.$root.unSelectAllControls();
      this.$root.$set('selectedItem', {});

      if ((this.isSublimationProduct() && this.isApparel() && !this.doesFrontAndBackDesignExist())) {
        helpers.alert('Sublimation Apparel products require both the front and back design.');
        return false;
      }

      if (designItems.front.length > 0 || designItems.back.length > 0) {
        this.$dispatch('details-tab-next-clicked');
      } else {
        helpers.alert("Unfortunately, you can\'t sell a blank item. You need to add text or art before you can continue.");
      }
    },
    generatePreview: function() {
      this.showLoading = true;
      this.showLoading = false;
    },
    getPricing: function() {
      if (this.isEmbroideryProduct())
        return parseFloat(this.$root.campaignData.pricing.dtgPrice) || 0.00;
      else
        return parseFloat(this.$root.campaignData.pricing.basePrice) || 0.00;
    },
    getSaleCount: function() {
      return this.$root.campaignData.goal;
    },
    resetDesign: function() {
      //this.$root.$set('designerItems.front', []);
      //this.$root.$set('designerItems.back', []);
    },
    previewCampaign: function(generateStepPreviews) {
      if (this.$root.designerItems.front.length > 0 || this.$root.designerItems.back.length > 0) {
        var that = this,
          preview_function = function() {
            that.$root.outputDesign();
            setTimeout(function() {
              var data = _.clone(that.$root.campaignData, true);

              if (that.selectedProduct) {
                if (that.selectedProduct.product.sublimation == 1) {
                  data.design.front.original = '';
                  data.design.front.upscaled = '';
                  data.design.back.original = '';
                  data.design.back.upscaled = '';
                }
              }

              Vue.http.post(that.$root.getRequestService().ajaxBase + 'preview', { preview_data: JSON.stringify(that.$root.clearDesignData(data)) }).then(function(response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                  var imageData = res.data;
                  that.$root.$set('preview.front.large', imageData.front.medium);
                  that.$root.$set('preview.front.thumbnail', imageData.front.small);
                  if (imageData.back) {
                    that.$root.$set('preview.back.large', imageData.back.medium);
                    that.$root.$set('preview.back.thumbnail', imageData.back.small);
                  }

                  if (generateStepPreviews !== true) {
                    that.$root.$set('preview.activeSide', that.$root.currentSide);

                    $('#preview_modal').modal({
                      backdrop: 'static',
                      keyboard: false,
                      show: true
                    });

                    helpers.hideProcessing();
                  } else {
                    that.$dispatch('on-post-force-preview-campaign');
                  }
                } else {
                  helpers.alert('There was an error generating the preview <br> Error Message: ' + res.message);
                }
              }, function() {
                helpers.alert('There was an error processing the request. Please retry again');
                helpers.hideProcessing(true);
              });
            }, 500);
          };
        if (generateStepPreviews !== true) {
          this.$root.$set('preview.activeSide', 'front');
          this.$root.unSelectAllControls();
          this.$root.$set('selectedItem', {});
          helpers.showProcessing(false);
        }
        preview_function();
      } else {
        helpers.alert("You can\'t preview a blank item. You need to add text or art before you can see the preview.");
      }
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    },
    isEmbroideryProduct: function() {
      return this.$root.isEmbroideryProduct();
    },
    getDesignerHelper() {
      return this.$root.getDesignerHelper();
    },
    isPhoneCaseProduct() {
      return this.$root.isPhoneCaseProduct();
    },
    isApparel() {
      return this.$root.isApparel();
    },
    doesFrontAndBackDesignExist() {
      return this.$root.doesFrontAndBackDesignExist()
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/rightControl.js